import { AuthOutcome, tenantConfOrDisplayError } from "./DialogCommons";
import { OidcClient } from "oidc-client-ts";
import { settings } from "../../../../../login/oidcSettings";
import { store } from "../../redux/store/store";
import { updateAuthDataForTenantConf } from "../../redux/feature/settings/configurations-slice";
import { validateString } from "../../utils/helpers/ObjectCheckerHelper";

export const refreshToken = async (tenantId: string): Promise<AuthOutcome> => {
  const tenantConfiguration = tenantConfOrDisplayError(tenantId);

  if (!validateString(tenantConfiguration?.authData?.refresh_token)) {
    return Promise.reject(new Error("NO_REFRESH_TOKEN"));
  }

  console.log("try to refresh token");

  // Create a new OidcClient using the tenant-specific IDP settings.
  const oidcClient = new OidcClient(settings(tenantConfiguration.idpUrl, tenantConfiguration.idpClientId));

  try {
    // Attempt to use the refresh token to obtain a new token.
    const signinResponse = await oidcClient.useRefreshToken({
      state: {
        refresh_token: tenantConfiguration.authData?.refresh_token,
        scope: undefined,
        session_state: null,
        profile: tenantConfiguration.authData.profile,
        data: undefined,
      },
    });

    // If no response is received, log an error and prompt a fresh login.
    if (!signinResponse) {
      console.error("OIDC client returned an empty response");
      return Promise.reject(new Error("FAIL_TO_REFRESH_TOKEN"));
    }

    console.log("token refreshed:", signinResponse);

    // Convert the signinResponse to a plain object, then update Redux store.
    const authData = JSON.parse(JSON.stringify(signinResponse));
    store.dispatch(updateAuthDataForTenantConf({ authData: authData, tenantId: tenantId }));

    // Return the new auth data as part of the AuthOutcome.
    return { authData: authData };
  } catch (e) {
    console.error("Error trying to refresh token", e);
    return Promise.reject(new Error("FAIL_TO_REFRESH_TOKEN"));
  }
};
